import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import LoadingButton from '@mui/lab/LoadingButton';
import { Container, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import API from "./CodeView/MyApi";
import Notification from "../Notification";

const ViperHome = () => {
  const [inputValue, setInputValue] = useState();

  const [testCase, setTestCase] = useState({result:[], isLoading: false, error: null });
  const navigate = useNavigate();

  const onSubmit = async () => {
    setTestCase({...testCase, isLoading: true})
    const payload = {
      query: inputValue,
    };
    try{
      const test_case = await API.postData("/viper/testcase", payload);
      const hashId = test_case.id;
      const startTime = new Date().getTime();
      const intervalCall = setInterval(async() => {
        if(new Date().getTime() - startTime > 180000){
            clearInterval(intervalCall);
            return;
        }
        const data = await API.getData(`/status?sha_id=${hashId}`);
        if( data.testcase || data.test_code ){
          clearInterval(intervalCall);
          setTestCase({...testCase, isLoading: false})
          navigate("/viper-table", { state: data.testcase || data.test_code });
        }
      }, 5000);
    }catch( error ){
      setTestCase({...testCase, isLoading: false, error})
    }
  };
  return (
    <Container className="form">
      <h1 style={{ textAlign: "center", marginBottom: "1rem" }}>Viper</h1>
      {testCase.error && <Notification displayNotification={true} severity={"error"} message="Something went wrong. Please try again later." />}
      <form>
        <Stack spacing={2}>
          <TextField
            label="Specify Test requirement"
            variant="outlined"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          <LoadingButton
            endIcon={<DownloadIcon />}
            disabled={!inputValue}
            onClick={onSubmit}
            variant="contained"
            loading={testCase.isLoading}
          >
            Submit
          </LoadingButton>
        </Stack>
      </form>
    </Container>
  );
};

export default ViperHome;
